import { Dispatch } from "redux"
import { deepCopy } from "client/utils"
import {
    AccountSettings,
    LoadAccountSettings,
    CopyDefaultProjectGroups,

    CopyDefaultCcApprovalLevels,
    CopyDefaultCcResponses,
    CopyDefaultCcReviewReviewTypes,

    CopyDefaultCcRequirementPriorities,
    CopyDefaultCcRequirementReviewMethods,
    CopyDefaultCcRequirementSmartCompliances,
    CopyDefaultCcRequirementStatuses,
    CopyDefaultCcRequirementTypes,

    CopyDefaultOkrMetrics,

    SaveAccountSettings,
    setSystemAccountSettings,
} from "client/store"

const ImportDefaultSettings = (accountId: number, dispatch: Dispatch) => (
    LoadAccountSettings(accountId)
    .then((settings) => {
        const newSettings: AccountSettings = deepCopy(settings)
        const isSuperAdmin = accountId === 1
        const promiseArray: Promise<any>[] = []

        if (!isSuperAdmin && !settings.project.defaultGroupsAssigned) {
            promiseArray.push(
                CopyDefaultProjectGroups(accountId, null, false).then(() => (
                    CopyDefaultCcApprovalLevels(accountId, null, false).then(() => {
                        newSettings.project.defaultGroupsAssigned = true
                    })
                )),
            )
        }

        // CC responses
        if (!isSuperAdmin && !settings.cc.defaultResponsesAssigned) {
            promiseArray.push(
                CopyDefaultCcResponses(accountId, null, false).then(() => {
                    newSettings.cc.defaultResponsesAssigned = true
                }),
            )
        }

        // CC review settings
        if (!isSuperAdmin && !settings.cc.defaultReviewItemTypesAssigned) {
            promiseArray.push(
                CopyDefaultCcReviewReviewTypes(accountId, null, false).then(() => {
                    newSettings.cc.defaultReviewItemTypesAssigned = true
                }),
            )
        }

        // CC requirements settings
        if (!isSuperAdmin && !settings.cc.defaultRequirementsPriorityAssigned) {
            promiseArray.push(
                CopyDefaultCcRequirementPriorities(accountId, null, false).then(() => {
                    newSettings.cc.defaultRequirementsPriorityAssigned = true
                }),
            )
        }
        if (!isSuperAdmin && !settings.cc.defaultRequirementsReviewMethodAssigned) {
            promiseArray.push(
                CopyDefaultCcRequirementReviewMethods(accountId, null, false).then(() => {
                    newSettings.cc.defaultRequirementsReviewMethodAssigned = true
                }),
            )
        }
        if (!isSuperAdmin && !settings.cc.defaultRequirementsSmartComplianceAssigned) {
            promiseArray.push(
                CopyDefaultCcRequirementSmartCompliances(accountId, null, false).then(() => {
                    newSettings.cc.defaultRequirementsSmartComplianceAssigned = true
                }),
            )
        }
        if (!isSuperAdmin && !settings.cc.defaultRequirementsStatusAssigned) {
            promiseArray.push(
                CopyDefaultCcRequirementStatuses(accountId, null, false).then(() => {
                    newSettings.cc.defaultRequirementsStatusAssigned = true
                }),
            )
        }
        if (!isSuperAdmin && !settings.cc.defaultRequirementsTypeAssigned) {
            promiseArray.push(
                CopyDefaultCcRequirementTypes(accountId, null, false).then(() => {
                    newSettings.cc.defaultRequirementsTypeAssigned = true
                }),
            )
        }

        // OKR settings
        if (!isSuperAdmin && !settings.okr.defaultMetricsAssigned) {
            promiseArray.push(
                CopyDefaultOkrMetrics(accountId, false).then(() => {
                    newSettings.okr.defaultMetricsAssigned = true
                }),
            )
        }

        return Promise.all(promiseArray).then(() => (
            SaveAccountSettings(accountId, newSettings)
            .then(() => {
                dispatch(setSystemAccountSettings(newSettings))
            })
        ))
    })
)
export default ImportDefaultSettings
